import React, { useState } from "react";

import { ChangeEventTimelineEvent } from "models";

import { Icon, Message as message } from "components";

import { fmtBytes, rawPayloadOf } from "pages/admin/verifications/utils/changeEventTimeline";

/** The payload is only serialised when someone opens it, and the closed state is one quiet link. */
export const ChangeEventRawJson = ({ event }: { event: ChangeEventTimelineEvent }) => {
  const [payload, setPayload] = useState<string | null>(null);

  const copy = () => {
    navigator.clipboard.writeText(payload ?? rawPayloadOf(event)).then(() => message({ content: "JSON copied" }));
  };

  return (
    <div className="ce-raw">
      <button type="button" className="ce-jsonlink" onClick={() => setPayload(payload === null ? rawPayloadOf(event) : null)}>
        <Icon iconName="tabler/code" size={14} />
        {payload === null ? "View raw JSON" : "Hide raw JSON"}
        <Icon iconName="tabler/arrow-right" size={14} />
      </button>
      {payload !== null && (
        <>
          {event.output === null && event.sizes.output > 0 && (
            <span className="ce-hint">{`output is ${fmtBytes(event.sizes.output)} and is not sent to this page; the values above stand in for it.`}</span>
          )}
          <pre className="ce-json">{payload}</pre>
          <button type="button" className="ce-linkish" onClick={copy}>
            copy JSON
          </button>
        </>
      )}
    </div>
  );
};
